import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Heart } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Merci ! Vous êtes inscrit à la newsletter.");
      setEmail("");
    } catch (err) {
      toast.error("Une erreur est survenue. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[hsl(var(--bg-inverse))] text-[hsl(var(--text-inverse))] mt-32" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <h3 className="font-serif text-3xl mb-3">Recette<span className="text-[hsl(var(--brand-primary))]">·</span>Diabete</h3>
          <p className="text-sm leading-relaxed text-[hsl(var(--text-inverse))]/70 max-w-md">
            Les recettes que vous aimez, repensées pour les personnes diabétiques.
            Index glycémique bas, guides experts, et une nouvelle façon de cuisiner — sans renoncer au goût.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-md" data-testid="newsletter-form">
            <div className="relative flex-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[hsl(var(--text-inverse))]/50" strokeWidth={1.5} />
              <input
                data-testid="newsletter-email-input"
                type="email"
                required
                placeholder="votre@email.fr"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-9 pr-3 py-3 text-sm rounded-sm bg-white/8 border border-white/15 text-white placeholder:text-white/40 focus:outline-none focus:border-[hsl(var(--brand-primary))]"
              />
            </div>
            <button
              data-testid="newsletter-submit-btn"
              type="submit"
              disabled={loading}
              className="btn-primary disabled:opacity-50"
            >
              {loading ? "…" : "S'inscrire"}
            </button>
          </form>
        </div>

        <div>
          <p className="overline text-white/50 mb-4">Naviguer</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/recettes" className="hover:text-[hsl(var(--brand-accent))]">Toutes les recettes</Link></li>
            <li><Link to="/cuisines-du-monde" className="hover:text-[hsl(var(--brand-accent))]">Cuisines du monde</Link></li>
            <li><Link to="/guides" className="hover:text-[hsl(var(--brand-accent))]">Guides diabète</Link></li>
            <li><Link to="/categories/entree" className="hover:text-[hsl(var(--brand-accent))]">Entrées</Link></li>
            <li><Link to="/categories/plat" className="hover:text-[hsl(var(--brand-accent))]">Plats</Link></li>
            <li><Link to="/categories/dessert" className="hover:text-[hsl(var(--brand-accent))]">Desserts</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline text-white/50 mb-4">À propos</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/a-propos" className="hover:text-[hsl(var(--brand-accent))]">Notre mission</Link></li>
            <li><Link to="/admin/login" className="hover:text-[hsl(var(--brand-accent))]" data-testid="footer-admin-link">Espace admin</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline text-white/50 mb-4">Légal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mentions-legales" className="hover:text-[hsl(var(--brand-accent))]" data-testid="footer-mentions-legales-link">Mentions légales</Link></li>
            <li><Link to="/cgu" className="hover:text-[hsl(var(--brand-accent))]" data-testid="footer-cgu-link">CGU</Link></li>
            <li><Link to="/politique-confidentialite" className="hover:text-[hsl(var(--brand-accent))]" data-testid="footer-privacy-link">Confidentialité</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 text-xs text-white/40 flex flex-wrap items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Recette-Diabete. Tous droits réservés.</span>
          <span className="flex items-center gap-1.5">Fait avec <Heart className="w-3 h-3 fill-[hsl(var(--brand-primary))] text-[hsl(var(--brand-primary))]" /> pour les diabétiques.</span>
        </div>
      </div>
    </footer>
  );
}
